import { render, staticRenderFns } from "./ColumnDisplayEditor.vue?vue&type=template&id=49247daa&"
import script from "./ColumnDisplayEditor.vue?vue&type=script&lang=ts&"
export * from "./ColumnDisplayEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnDisplayEditor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports